
import { useEffect } from 'react';

interface AmplitudeInstance {
  track: (eventName: string, properties?: Record<string, unknown>) => void;
  setUserId: (userId: string) => void;
  identify: (identify: Record<string, unknown>) => void;
  add: (plugin: unknown) => void;
  init: (apiKey: string, options?: Record<string, unknown>) => void;
}

interface SessionReplayPlugin {
  plugin: (options: Record<string, unknown>) => unknown;
}

declare global {
  interface Window {
    amplitude?: AmplitudeInstance;
    sessionReplay?: SessionReplayPlugin;
  }
}

export const useAmplitude = () => {
  useEffect(() => {
    // Amplitude initialization check removed
  }, []);

  const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
    if (typeof window !== 'undefined' && window.amplitude) {
      window.amplitude.track(eventName, properties);
    }
  };

  const setUserId = (userId: string) => {
    if (typeof window !== 'undefined' && window.amplitude) {
      window.amplitude.setUserId(userId);
    }
  };

  const identify = (userProperties: Record<string, unknown>) => {
    if (typeof window !== 'undefined' && window.amplitude) {
      window.amplitude.identify(userProperties);
    }
  };

  const isAvailable = typeof window !== 'undefined' && !!window.amplitude;

  return {
    trackEvent,
    setUserId,
    identify,
    isAvailable
  };
};
